export default __webpack_public_path__ + "static/media/pending-kyc-verification-active.38b0d87d.svg";